import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import AiTeamDropDown from "../Components/AiTeamDropDown";
import LockIcon from "../Assets/LockImg.png";
import SparkleIcon from "../Assets/Icons/sparkleIcon.svg";
import LLMIcon from "../Assets/Icons/llmIcon.svg";
import KPIIcon from "../Assets/Icons/KptIcon.svg";
import DataQualityIcon from "../Assets/Icons/dataQualityIcon.svg";
import NlpIcon from "../Assets/Icons/visionIcon.svg";
import PowerIcon from "../Assets/Icons/powerIcon.svg";
import RoboticsIcon from "../Assets/Icons/roboticsIcon.svg";
import KnowledgeIcon from "../Assets/Icons/knowledgeIcon.svg";
import MachineLearningIcon from "../Assets/Icons/machineLearningIcon.svg";
import AIEthicsIcon from "../Assets/Icons/aiEthicsIcon.svg";

export default function AskGenerativeAiEmpty() {
  return (
    <DashboardLayout>
      <div className="h-[100vh] z-10 w-[90%] fixed bg-black/30 flex items-center justify-center backdrop-blur-xl">
        <div className="w-[35%]">
          <div className="flex flex-col items-center gap-3">
            <img className="w-[6.5rem]" src={LockIcon} />
            <p className="text-[1.2rem] text-[#F9FAFB] font-[600]">
              This is a PLUS feature
            </p>  
            <p className="text-[0.94rem] text-[#E5E7EB] font-[500] text-center">
            It is an AI-assistant to empower stakeholders build their people AI ecosystem.  Give it instructions in natural language and it will act on it.  
            </p>
            <button className="w-[10.9rem] h-[2.6rem] text-[0.92rem] text-white rounded-[8px] border-[1px] flex items-center justify-center gap-2">
              <img src={SparkleIcon} />
              Upgrade to plus
            </button>
          </div>
        </div>
      </div>
      <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs links={[{ name: "Generative AI", link: "dsads" }]} />
        <h1 className="text-xl font-semibold">Ask Generative Al</h1>
        <p className="text-[1rem] text-[#6B7280] mt-[-13px]">
          Al People Ecosystem Query in Natural Language. The Right Al team for
          the Right Project
        </p>
        <div className="flex items-center gap-3">
          <AiTeamDropDown width="28rem" text="Al People Ecosystem Index*" />
          <AiTeamDropDown width="28rem" text="Al People Ecosystem Database" />
          <button className="w-[7rem] h-[2.5rem] rounded-[8px] text-[0.85rem] font-[500] text-[white] bg-[#942A27]">
            Add new index
          </button>
        </div>
      </section>
      <section className="bg-[#f9fafb] w-full h-screen pt-6 px-6 pb-8">
        <div>
          <div className="flex items-start flex-col gap-1">
            <label className="text-[0.95rem] text-[#111928] font-[500]">
              Query *
            </label>
            <textarea
              placeholder="Discover Insights in your AI People Ecosystem."
              className="w-full h-[6.8rem] border-[1px] border-[#D1D5DB] bg-white text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px] pt-2 px-2 resize-none"
            ></textarea>
            <button className="w-[4.4rem] h-[2.3rem] rounded-[8px] text-[0.85rem] font-[500] text-[white] bg-[#942A27] mt-2">
              Search
            </button>
          </div>
          <div className="flex items-start flex-col gap-1 mt-8">
            <label className="text-[0.95rem] text-[#111928] font-[500]">
              Output
            </label>
            <div className="w-full h-[23rem] border-[1px] border-[#D1D5DB] bg-white rounded-[8px]"></div>
          </div>
        </div>
      </section>
    </DashboardLayout>
  );
}
